<template>
	<div>
		<div v-for="(val, key) in options" v-if="typeof val === 'object' && !Array.isArray(val)" :key="key">
			<div v-if="val.type">
				<div v-if="val.type.includes('header')">
					<p class="add-event-amenities-header ma-0 mb-1 mt-3">{{val.value}}</p>
				</div>
				<div v-if="val.type.includes('radio')" class="ml-3">
					<v-radio-group hide-details :id="key" v-model="selectionInputs[key]" class="pa-0 mt-2">
						<div v-for="(radioVal, radioKey, index) in val.radio_vals" :key="index" class="p-relative">
							<v-radio
								ref="key"
								:id="radioKey"
								:value="radioKey"
								@click="updateRadioInput(key, radioKey)"
								:key="radioKey"
								class="add-event-radio-selection-small"
							></v-radio>
							<div class="add-event-radio-selection-small-title p-absolute" style="cursor: pointer" @click="simulateClick(key, radioKey)">
								{{ radioVal.value }}
							</div>
						</div>
					</v-radio-group>
				</div>
				<div v-if="val.type.includes('int')" class="ml-3">
					<v-text-field :id="key" :value="getInputVal(key)" @change="updateInput(key)" type="number" :label="val.value" style="width: 400px;"></v-text-field>
				</div>
				<v-layout v-if="val.type.includes('text')" class="ml-3">
					<v-text-field :id="key" :value="getInputVal(key)" @change="updateInput(key)" :label="val.value" style="width: 400px;"></v-text-field>
				</v-layout>
				<v-layout v-if="val.type.includes('money')" class="ml-3">
					<v-text-field :id="key" :value="getInputVal(key)" @change="updateInput(key)" :label="val.value" prefix="$" style="width: 100px;"></v-text-field>
				</v-layout>
			</div>
			<v-checkbox v-else-if="key !== 'radio_vals'" hide-details @change="updateSelection" :label="val.value" :value="key" v-model="selectionComputed" class="ma-0 pa-0 add-event-radio-selection-small"></v-checkbox>
			<div v-if="isSelected(key, val)" class="ml-3">
				<div v-for="(val2, key2) in val" v-if="typeof val2 === 'object' && !Array.isArray(val2)" :key="key2">
					<div v-if="val2.type">
						<div v-if="val2.type.includes('header')">
							<p class="add-event-amenities-sub-header">{{val2.value}}</p>
						</div>
						<div v-if="val2.type.includes('radio')" class="ml-3">
							<v-radio-group hide-details :id="key2" v-model="selectionInputs[key2]" class="pa-0 ma-0 mb-3">
								<div v-for="(radioVal, radioKey, index) in val2.radio_vals" :key="index" class="p-relative">
									<v-radio
										:ref="key2"
										:data-name="radioKey"
										data-type="radio"
										:id="radioKey"
										:value="radioKey"
										@change="updateRadioInput(key2, radioKey)"
										:key="radioKey"
										class="add-event-radio-selection-small"
									></v-radio>
									<div class="add-event-radio-selection-small-title p-absolute" style="cursor: pointer" @click="simulateClick(key2, radioKey)">
										{{ radioVal.value }}
									</div>
								</div>
							</v-radio-group>
						</div>
						<div v-if="val2.type.includes('int')" class="ml-3">
							<v-text-field :id="key2" :value="getInputVal(key2)" @change="updateInput(key2)" type="number" :label="val2.value" style="width: 400px;"></v-text-field>
						</div>
						<v-layout v-else-if="val2.type.includes('text')" class="ml-3">
							<v-text-field :id="key2" :value="getInputVal(key2)"  @change="updateInput(key2)" :label="val2.value" style="width: 400px;"></v-text-field>
						</v-layout>
						<v-layout v-else-if="val2.type.includes('money')" class="ml-3">
							<v-text-field :id="key2" :value="getInputVal(key2)" @change="updateInput(key2)" :label="val2.value" prefix="$" style="width: 100px;"></v-text-field>
						</v-layout>
					</div>
					<div class="p-relative" v-else-if="key2 !== 'radio_vals'">
						<v-checkbox
							:ref="key2"
							:id="key2"
							:data-name="key2"
							data-type="checkbox"
							class="ma-0 pa-0 add-event-radio-selection-small"
							:value="key2"
							@change="updateSelection"
							v-model="selectionComputed"
							hide-details
						></v-checkbox>
						<div class="add-event-radio-selection-small-title p-absolute" style="cursor: pointer" @click="simulateClick(key2, key2)">
							{{ val2.value }}
						</div>
					</div>
					<div v-if="isSelected(key2, val2)" class="ml-3">
						<div v-for="(val3, key3) in val2" v-if="typeof val3 === 'object' && !Array.isArray(val3)" :key="key3">
							<div v-if="val3.type">
								<div v-if="val3.type.includes('header')">
									<p class="add-event-amenities-sub-header">{{val3.value}}</p>
								</div>
								<div v-if="val3.type.includes('radio')" class="ml-3">
									<v-radio-group hide-details :id="key3" v-model="selectionInputs[key3]" class="pa-0">
										<v-radio v-for="(radioVal, radioKey) in val3.radio_vals" :id="radioKey" :value="radioKey" :label="radioVal.value" @change="updateRadioInput(key3, radioKey)" :key="radioKey" class="add-event-radio-selection-small">
										</v-radio>
									</v-radio-group>
								</div>
								<div v-if="val3.type.includes('int')" class="ml-3">
									<v-text-field :id="key3" :value="getInputVal(key3)" @change="updateInput(key3)" type="number" :label="val3.value" style="width: 400px;"></v-text-field>
								</div>
								<v-layout v-else-if="val3.type.includes('text')" class="ml-3">
									<v-textarea v-if="val3.type.includes('multi')" :id="key3" :value="getInputVal(key3)"  @change="updateInput(key3)" :label="val3.value" style="width: 400px;"></v-textarea>
									<v-text-field v-else :id="key3" :value="getInputVal(key3)" @change="updateInput(key3)" :label="val3.value" style="width: 400px;"></v-text-field>
								</v-layout>
								<v-layout v-else-if="val3.type.includes('money')" class="ml-3">
									<v-text-field :id="key3" :value="getInputVal(key3)" @change="updateInput(key3)" :label="val3.value" prefix="$" style="width: 100px;"></v-text-field>
								</v-layout>
							</div>
							<div class="p-relative mb-1" v-else-if="key3 !== 'radio_vals'">
								<v-checkbox
									:ref="key3"
									:id="key3"
									:data-name="key3"
									data-type="checkbox"
									class="ma-0 pa-0 add-event-radio-selection-small"
									:value="key3"
									@change="updateSelection"
									v-model="selectionComputed"
									hide-details
								></v-checkbox>
								<div class="add-event-radio-selection-small-title p-absolute" style="cursor: pointer" @click="simulateClick(key3, key3)">
									{{ val3.value }}
								</div>
							</div>
							<!-- <v-checkbox v-else-if="key3 !== 'radio_vals'" @change="updateSelection" hide-details :label="val3.value" :value="key3" v-model="selectionComputed" class="ma-0 pa-0 add-event-radio-selection-small"></v-checkbox> -->

							<div v-if="isSelected(key3, val3)" class="ml-3">
								<div v-for="(val4, key4) in val3" v-if="typeof val4 === 'object' && !Array.isArray(val4)" :key="key4">
									<div v-if="val4.type">
										<div v-if="val4.type.includes('header')">
											<p class="add-event-amenities-sub-header">{{val4.value}}</p>
										</div>
										<div v-if="val4.type.includes('radio')" class="ml-3">
											<v-radio-group hide-details :id="key4" v-model="selectionInputs[key4]" class="pa-0">
												<v-radio v-for="(radioVal, radioKey) in val4.radio_vals" :id="radioKey" :value="radioKey" :label="radioVal.value" @change="updateRadioInput(key4, radioKey)" :key="radioKey" class="add-event-radio-selection-small">
												</v-radio>
											</v-radio-group>
										</div>
										<div v-if="val4.type.includes('int')" class="ml-3">
											<v-text-field :id="key4" :value="getInputVal(key4)" @change="updateInput(key4)" type="number" :label="val4.value" style="width: 400px;"></v-text-field>
										</div>
										<v-layout v-else-if="val4.type.includes('text')" class="ml-3">
											<v-textarea v-if="val4.type.includes('multi')" :id="key4" :value="getInputVal(key4)"  @change="updateInput(key4)" :label="val4.value" style="width: 400px;"></v-textarea>
											<v-text-field v-else :id="key4" :value="getInputVal(key4)"  @change="updateInput(key4)" :label="val4.value" style="width: 400px;"></v-text-field>
										</v-layout>
										<v-layout v-else-if="val4.type.includes('money')" class="ml-3">
											<v-text-field :id="key4" :value="getInputVal(key4)" @change="updateInput(key4)" :label="val4.value" prefix="$" style="width: 100px;"></v-text-field>
										</v-layout>
									</div>
									<v-checkbox v-else-if="key4 !== 'radio_vals'" @change="updateSelection" hide-details :label="val4.value" :value="key4" v-model="selectionComputed" class="ma-0 pa-0 add-event-radio-selection-small"></v-checkbox>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import clone from '~/utils/clone'
import { mapGetters } from 'vuex'
export default {
	props: [
		'selectionOptions',
		'storeSelections',
		'storeInputs',
		'selectionProp',
		'selectionInputProp',
		'mutation'
	],
	data() {
		return {
			selectedEventTags: [],
			options: [],
			selections: [],
			selectionInputs: {}
		}
	},
	methods: {
		updateSelection() {
			this.$store.commit(this.mutation, {
				prop: this.selectionProp,
				value: [...this.selections]
			})
		},
		updateInput(key) {
			Vue.set(this.selectionInputs, key, document.getElementById(key).value)
			// this.selectionInputs[key] = document.getElementById(key).value
			this.$store.commit(this.mutation, {
				prop: this.selectionInputProp,
				value: Object.assign({}, this.selectionInputs)
			})
		},
		simulateClick(key, val) {
			let el = this.$refs[key].find(ref => ref.$attrs['data-name'] === val)
			if (el.$attrs['data-type'] === 'radio') {
				el.$emit('change', val)
			} else if (el.$attrs['data-type'] === 'checkbox') {
				el.simulate('change')
			}
		},
		updateRadioInput(key, radioVal) {
			Vue.set(
				this.selectionInputs,
				key,
				document.getElementById(radioVal).value
			)
			// console.log(this.selectionInputs)
			this.$store.commit(this.mutation, {
				prop: this.selectionInputProp,
				value: Object.assign({}, this.selectionInputs)
			})
		},
		isSelected(key, val) {
			if (this.selections.includes(key)) {
				return true
			} else {
				if (val.type) {
					if (val.type.includes('header')) {
						return true
					}
				}
			}
		},
		getInputVal(key) {
			if (this.selectionInputs.hasOwnProperty(key)) {
				return this.selectionInputs[key]
			}
		}
	},
	mounted() {
		if (this.storeSelections) {
			Vue.set(this, 'selections', [...this.storeSelections])
		}
		if (this.storeInputs) {
			Vue.set(this, 'selectionInputs', {...this.storeInputs})
		}

		this.options = this.selectionOptions
	},
	computed: {
		selectionComputed: {
			get() {
				return this.storeSelections
			},
			set(val) {
				this.selections = val
			}
		}
	}
}
</script>
